import {Component, OnInit, OnDestroy} from "@angular/core";
import {MatDialog, MAT_DIALOG_DATA} from "@angular/material";
import {AddLeadDialogComponent} from "../../../shared/add-lead-dialog/add-lead-dialog.component";
import {
  AdminService,
  CommonService,
  LeadService,
  AlertService,
  ProfileService,
  ProjectService,
} from "../../../_services/";
import {ActivatedRoute, Router} from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators,
} from "@angular/forms";
import {AddProjectDialogComponent} from "../../../shared/add-project-dialog/add-project-dialog.component";

import {ToastrService} from "ngx-toastr";
import {EditContactDialogComponent} from "../edit-contact-dialog/edit-contact-dialog.component";

import {AddAppointmentDialogComponent} from "../../../shared/add-appointment-dialog/add-appointment-dialog.component";
import {AddReminderDialogComponent} from "../../../shared/add-reminder-dialog/add-reminder-dialog.component";
import {AddNoteDialogComponent} from "../../../shared/add-note-dialog/add-note-dialog.component";
import {environment} from "../../../../environments/environment";

import * as moment from "moment";
import * as XLSX from "xlsx";
import {Subscription} from "rxjs";
import {AngularFireFunctions} from "@angular/fire/functions";

// For the search only version
import algoliasearch from "algoliasearch";
import {EditReminderDialogComponent} from "src/app/shared/edit-reminder-dialog/edit-reminder-dialog.component";

const client = algoliasearch(
  environment.algolia.appId,
  environment.algolia.adminAPIKey
);
const index = client.initIndex("contacts");
@Component({
  selector: "app-contact-detail",
  templateUrl: "./contact-detail.component.html",
  styleUrls: ["./contact-detail.component.scss"],
  providers: [AngularFireFunctions],
})
export class ContactDetailComponent implements OnInit {
  filterForm: FormGroup;
  panelOpenState = false;
  contactList: any;
  items: any[] = [];
  excelArray: any[] = [];
  fileName = "Leads.xlsx";
  successMsg: any;
  errMsg: any;
  // searchAreaStatus:Boolean;
  contactType: String = "";
  jobFunctionList: any[] = [];
  headingLabel: String = "";
  addLabel: String = "";
  appointmentList: any[] = [];
  reminderList: any[] = [];
  noteList: any[] = [];
  designerList: any[] = [];
  contactSourceList: any[] = [];
  showrooms: any;
  showFilter: Boolean = false;
  contactId: String;
  projects: any[] = [];
  showContact: Boolean;
  ownerFirstName: string;
  ownerLastName: string;
  public contactNotExists = false;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  private subscription4: Subscription;
  private subscription5: Subscription;
  private subscription6: Subscription;
  private subscription7: Subscription;
  private subscription8: Subscription;
  private subscription9: Subscription;
  private subscription10: Subscription;
  showShareForm = false;
  searchContacts: any[] = [];
  shareForm: FormGroup;
  shareRecord: any;
  constructor(
    public dialog: MatDialog,
    private _common: CommonService,
    public _admin: AdminService,
    public _lead: LeadService,
    private _project: ProjectService,
    private _alert: AlertService,
    private _profile: ProfileService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private _toastr: ToastrService,
    private fns: AngularFireFunctions
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.contactId = params.get("id");

      this._profile.updateTab(this.contactId);
    });
    this.filterForm = this.fb.group({
      owner_contact_id: ["", []],
      contact_source_id: ["", []],
      showroom: ["", []],
    });

    this._profile.contactTypeTitle.subscribe((title) => {
      this.headingLabel = title;
      if (this.headingLabel.charAt(this.headingLabel.length - 1) == "s") {
        this.addLabel = this.headingLabel.substring(
          0,
          this.headingLabel.length - 1
        );
      }
    });

    // get contact type...
    this.route.paramMap.subscribe((params) => {
      this.contactType = params.get("contactType");
    });
    this.route.params.subscribe((routeParams) => {
      this.getContactList();
      if (this.headingLabel == "Contacts") {
        this.headingLabel =
          this.contactType != null
            ? this.capitalizeString(this.contactType.replace(/_/g, " "))
            : "Contacts";
      }
      if (this.headingLabel.charAt(this.headingLabel.length - 1) == "s") {
        this.addLabel = this.headingLabel.substring(
          0,
          this.headingLabel.length - 1
        );
      } else {
        this.addLabel = this.headingLabel;
      }
    });

    // this._profile.leadSearchArea.subscribe(status=>{
    //   this.searchAreaStatus = status['show'];
    // })
    this.getJobFunctionList();
    this.getDesignerList();
    this.getcontactSourceList();
    this.getShowroomList();
    this.shareForm = this.fb.group({
      keyword: ["", []],
      recipient_contact_id: ["", []],
      message: ["", []],
    });
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  capitalizeString(string) {
    return string
      .split(" ")
      .map((item) => item.replace(item.charAt(0), item.charAt(0).toUpperCase()))
      .join(" ");
  }

  exportexcel(): void {
    /* table id is passed over here */
    //  let element = document.getElementById('lead-listing');
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelArray);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  toggleShareForm() {
    this.showShareForm = !this.showShareForm;
  }

  // Search Algolia...
  searchAlgolia(form) {
    this.searchContacts = [];
    const requestOptions = {
      headers: {},
    };
    // Search Contacts...
    index.search(form.value.keyword, requestOptions).then(({hits}) => {
      if (form.value.keyword != "") {
        this.searchContacts = [];
        hits.forEach((item: any) => {
          if (item.contact_type_id == "staff") {
            this.searchContacts.push({
              owner_first_name: item["owner_first_name"],
              owner_last_name: item["owner_last_name"],
              first_name: item["first_name"],
              last_name: item["last_name"],
              mobile_phone: item["mobile_phone"],
              email: item["email"],
              objectID: item["objectID"],
            });
          }
        });
      }
    });
  }

  onFormSubmit(): void {
    this.errMsg = "";
    this.successMsg = "";
    if (this.shareForm.invalid) {
      return;
    }
    let form = this.shareForm.value;
    const obj = {
      sender_contact_id: localStorage.getItem("contactId"),
      recipient_contact_id: form.recipient_contact_id,
      record_id: this.contactId,
      comment: form.message,
      record_type: "contact",
    };
    if (window.location.host.includes("localhost")) {
      this.fns.functions.useFunctionsEmulator("http://localhost:5000");
    }
    this._common.showLoader(true);
    const recordShare = this.fns.httpsCallable("record_share");
    recordShare(obj).subscribe(
      (result) => {
        this._common.showLoader(false);
        if (result.outcome === "success") {
          this.shareForm.reset();
          this.successMsg = result.message;
          this.showShareForm = false;
        } else {
          this.errMsg = result.message;
        }
      },
      (err) => {
        this.errMsg =
          err && err.message ? err.message : "Something went wrong!";
      }
    );
  }

  selectContact(item) {
    let fullName = item.first_name + " " + item.last_name;
    this.shareForm.patchValue({
      keyword: fullName,
      recipient_contact_id: item.objectID,
    });

    this.searchContacts = [];
  }

  getContactList() {
    this.items = [];
    this._common.showLoader(true);
    this.subscription = this._lead.getContactById(this.contactId).subscribe(
      (res: any) => {
        if (res && res.payload && res.payload.exists == false) {
          this.contactNotExists = true;
          return;
        }
        this.contactList = res;
        const contactShowroomArr =
          this.contactList.payload.data() &&
          this.contactList.payload.data().showroom &&
          this.contactList.payload.data().showroom.length > 0
            ? this.contactList.payload
                .data()
                .showroom.map((item) => item.showroom_id)
            : [];

        // Code to Check is project will be visible or not.

        if (
          localStorage.getItem("uid") == "9052" &&
          (contactShowroomArr.includes("131917") ||
            contactShowroomArr.includes("131910"))
        ) {
          this.showContact = true;
        } else if (
          localStorage.getItem("uid") == "13420" &&
          (contactShowroomArr.includes("131917") ||
            contactShowroomArr.includes("131910"))
        ) {
          this.showContact = true;
        } else if (
          localStorage.getItem("uid") == "9428" &&
          (contactShowroomArr.includes("131917") ||
            contactShowroomArr.includes("131910"))
        ) {
          this.showContact = true;
        } else if (
          localStorage.getItem("uid") == "12917" ||
          localStorage.getItem("uid") == "9324" ||
          localStorage.getItem("uid") == "JI4HufuwBFRUZWU02NYVJ2wpJUf1" ||
          localStorage.getItem("uid") == "14071" ||
          localStorage.getItem("uid") == "9624" ||
          localStorage.getItem("uid") == "13928" ||
          localStorage.getItem("uid") == "9613" ||
          localStorage.getItem("uid") == "13831" ||
          localStorage.getItem("uid") == "1" ||
          localStorage.getItem("uid") == "13575" ||
          localStorage.getItem("uid") == "12464" ||
          localStorage.getItem("uid") == "14109"
        ) {
          this.showContact = true;
        } else if (
          localStorage.getItem("uid") == "14564" &&
          (this.contactId === "422690465" ||
            this.contactId === "422690607" ||
            this.contactId === "422638964")
        ) {
          this.showContact = true;
        } else if (
          localStorage.getItem("uid") == "r2dSyCJfjhd5vuW4QMvqGYKY7483" &&
          this.contactId === "422680998"
        ) {
          this.showContact = true;
        } else {
          // Owner contact id check
          this.subscription2 = this._lead
            .getContactDetail(localStorage.getItem("uid"))
            .subscribe(
              (res) => {
                const ownerContactId =
                  this.contactList.payload.data()["owner_contact_id"];
                this.ownerFirstName =
                  this.contactList.payload.data()["owner_first_name"];
                this.ownerLastName =
                  this.contactList.payload.data()["owner_last_name"];
                if (ownerContactId === localStorage.getItem("contactId")) {
                  this.showContact = true;
                } else {
                  this.showContact = false;
                }
              },
              (err) => {
                this.errMsg =
                  err.error && err.error.message
                    ? err.error.message
                    : "Something went wrong!";
              }
            );
        }

        this.subscription3 = this._admin
          .getClientProjectList(this.contactId)
          .subscribe(
            (result) => {
              this.projects = result.map((item) => item.payload.doc.data());
              // fetch appointment list
              this.subscription4 = this._lead
                .getAppointmentList({contactId: this.contactId})
                .subscribe(
                  (result) => {
                    this.appointmentList = result;
                    // fetch reminder list...
                    this.subscription5 = this._lead
                      .getReminderList({contactId: this.contactId})
                      .subscribe(
                        (result2) => {
                          this.reminderList = result2;
                          // fetch notes list...
                          this.subscription6 = this._lead
                            .getNotesList({contactId: this.contactId})
                            .subscribe(
                              (result3) => {
                                this._common.showLoader(false);

                                this.noteList = result3;
                                // for (let k=0;k<this.contactList.length;k++){
                                // bind appointment list with contact list
                                let contactAppointment = [];
                                for (
                                  let l = 0;
                                  l < this.appointmentList.length;
                                  l++
                                ) {
                                  if (
                                    this.appointmentList[l].payload.doc.data()
                                      .contact_id == this.contactList.payload.id
                                  ) {
                                    contactAppointment.push(
                                      this.appointmentList[l].payload.doc.data()
                                    );
                                  }
                                }
                                this.contactList.appointmentList =
                                  contactAppointment;
                                //bind reminder list with contact list
                                let contactReminder = [];
                                for (
                                  let l = 0;
                                  l < this.reminderList.length;
                                  l++
                                ) {
                                  if (
                                    this.reminderList[l].payload.doc.data()
                                      .contact_id == this.contactList.payload.id
                                  ) {
                                    contactReminder.push(
                                      this.reminderList[l].payload.doc.data()
                                    );
                                  }
                                }
                                this.contactList.reminderList = contactReminder;
                                //bind notes list with contact list
                                let contactNotes = [];
                                for (let m = 0; m < this.noteList.length; m++) {
                                  if (
                                    this.noteList[m].payload.doc.data()
                                      .contact_id == this.contactList.payload.id
                                  ) {
                                    contactNotes.push(
                                      this.noteList[m].payload.doc.data()
                                    );
                                  }
                                }
                                this.contactList.notesList = contactNotes;

                                // }
                              },
                              (err) => {
                                this._common.showLoader(false);
                                this._alert.error(
                                  err.error && err.error.message
                                    ? err.error.message
                                    : "Something went wrong!"
                                );
                              }
                            );
                        },
                        (err) => {
                          this._common.showLoader(false);
                          this._alert.error(
                            err.error && err.error.message
                              ? err.error.message
                              : "Something went wrong!"
                          );
                        }
                      );
                  },
                  (err) => {
                    this._common.showLoader(false);
                    this._alert.error(
                      err.error && err.error.message
                        ? err.error.message
                        : "Something went wrong!"
                    );
                  }
                );
            },
            (err2) => {
              this._common.showLoader(false);
              this._alert.error(
                err2.error && err2.error.message
                  ? err2.error.message
                  : "Something went wrong!"
              );
            }
          );

        for (let i = 0; i < this.contactList.length; i++) {
          let obj = {};
          obj["first_name"] = this.contactList[i].payload.doc.data().first_name;
          obj["last_name"] = this.contactList[i].payload.doc.data().last_name;
          obj["address"] = this.contactList[i].payload.doc.data().address;
          obj["designer"] = "";
          obj["phone"] = this.contactList[i].payload.doc.data().phone;
          obj["email"] = this.contactList[i].payload.doc.data().email;
          obj["date_created"] = new Date(
            this.contactList[i].payload.doc.data().date_created
          );
          // obj['date_created'] = moment(this.items[i].payload.doc.data().date_created.toDate()).format('YYYY-MM-DD');
          this.excelArray.push(obj);
        }
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error(
          error.error && error.error.message
            ? error.error.message
            : "Something went wrong!"
        );
      }
    );
  }

  // get job function list...
  getJobFunctionList() {
    this._common.showLoader(true);
    this.subscription7 = this._admin.getJobFunctionList().subscribe(
      (result) => {
        for (let item of result) {
          this.jobFunctionList.push({
            name: item.payload.doc.data()["name"],
            id: item.payload.doc.id,
            selected: false,
          });
        }
      },
      (err) => {
        this._common.showLoader(false);
        this._alert.error(
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!"
        );
      }
    );
  }

  openAddLeadDialog(modalType) {
    this.dialog.open(AddLeadDialogComponent, {
      width: "auto",
      data: {
        modalType: modalType,
      },
    });
  }

  openEditContactDialog(id, data) {
    let dialogRef = this.dialog.open(EditContactDialogComponent, {
      width: "auto",
      data: {
        id: id,
        jobFunctionList: this.jobFunctionList,
        contactData: data,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      // this.getUserList(localStorage.getItem('uid'))
    });
  }

  checkArray(item: any) {
    return Array.isArray(item);
  }

  deleteLead(id, algolia_object_id) {
    this._common.showLoader(true);
    // index.deleteObjects([algolia_object_id]).then(({ objectIDs }) => {
    this._lead
      .deleteLead(id)
      .then((res) => {
        this._lead.deleteLeadProject("zhK8LF9uDy5phdprP8RQ").subscribe(
          (res2) => {
            this.router.navigate(["contacts"]);
            this._toastr.success(`Contact deleted successfully!`, "", {
              timeOut: 4000,
            });
          },
          (err) => {
            this.errMsg = err.error.message
              ? err.error.message
              : "Something went wrong!";
          }
        );
      })
      .catch((err) => {
        this.errMsg = err.error.message
          ? err.error.message
          : "Something went wrong!";
      });

    // })
  }

  openEditReminderDilaog(id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(EditReminderDialogComponent, {
      width: "auto",
      data: {
        reminder_id: id,
      },
    });
  }

  // open add appointment dialog
  openAddAppointmentDialog(id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(AddAppointmentDialogComponent, {
      width: "auto",
      data: {
        contact_id: id,
        category: "contact",
      },
    });
  }
  // Add open reminder dialog
  openAddReminderDilaog(id, owner_contact_id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(AddReminderDialogComponent, {
      width: "auto",
      data: {
        contact_id: id,
        owner_contact_id: owner_contact_id,
        category: "contact",
      },
    });
  }

  // add note dialog
  openAddNoteDilaog(id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(AddNoteDialogComponent, {
      width: "auto",
      data: {
        contact_id: id,
        category: "contact",
      },
    });
  }

  // get designer list...
  getDesignerList() {
    this._common.showLoader(true);
    this.subscription8 = this._lead.getDesignerList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.designerList = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  // get contact source list
  getcontactSourceList() {
    this._common.showLoader(true);
    this.subscription9 = this._admin.getContactSourceList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.contactSourceList = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  // get showroom list...
  getShowroomList() {
    this._common.showLoader(true);
    this.subscription10 = this._admin.geShowroomList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.showrooms = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  openAddProjectDialog(client_id) {
    this.dialog.open(AddProjectDialogComponent, {
      width: "auto",
      data: {
        client_id: client_id,
        source: "contact",
        modalSource: "contact",
      },
    });
  }

  /*
          // owner_contact_id : owner_contact_id,
        // address : address,
        // first_name: first_name,
        // last_name: last_name,
        // source: 'contact',
        // showroom_id : showroom && showroom.length>0 ? showroom[0].showroom_id  :'',

  */

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
    if (this.subscription4) this.subscription4.unsubscribe();
    if (this.subscription5) this.subscription5.unsubscribe();
    if (this.subscription6) this.subscription6.unsubscribe();
    if (this.subscription7) this.subscription7.unsubscribe();
    if (this.subscription8) this.subscription8.unsubscribe();
    if (this.subscription9) this.subscription9.unsubscribe();
    if (this.subscription10) this.subscription10.unsubscribe();
  }
}
